import type { OsasCloseUnfinishedExaminationData } from '@common/validation/customControls/osas/osasCloseUnfinishedExaminationSchema';
import { AbortProcessReasons } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';
import { useProcessActivityEditContext } from '@frontend/utils';
import { SelectFormGroup } from '../../processActivityFormGroupFields';

export function OsasCloseUnfinishedExaminationEdit(): JSX.Element {
    const { onChange } = useProcessActivityEditContext<OsasCloseUnfinishedExaminationData>();
    const translate = getSelectedLanguage();

    return (
        <SelectFormGroup
            fieldKey="reason"
            isRequired={true}
            label={translate.request.abortProcessConfirmation}
            onChange={(value) =>
                onChange(
                    {
                        reason: value as AbortProcessReasons | null,
                    },
                    'reason'
                )
            }
            options={getProcessAbortReasons()}
            placeholder={translate.request.abortProcessMessage}
        />
    );

    function getProcessAbortReasons() {
        return Object.values(AbortProcessReasons)
            .filter((value) => !value.startsWith('cardio'))
            .map((value) => ({
                label: translate.abortProcessReasonsEnum[value],
                value,
            }));
    }
}
